// This file contains utility functions that are used throughout the project.

import { DEFAULT_THEME } from 'lib/constants';
import { format } from 'date-fns';

//Cookies utility functions
export const setCookie = (name: string, value: string) => {
  document.cookie = `${name}=${value};path=/`;
};

export const getCookie = (name: string): string | null => {
  const cookieName = `${name}=`;
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
  return null;
};

// Theme function
export const getThemeClass = (theme: string) => {
  return theme ? `theme-${theme.toLowerCase()}` : DEFAULT_THEME;
};

// Blog date format
export function formatBlogDate(dateValue?: string): string {
  if (!dateValue) return '';
  return format(new Date(dateValue), 'MMM dd, yyyy'); // Example: "Wed 29, 2025"
}

export function formatDate(dateInput: string | Date | number | undefined): string {
  if (!dateInput) return '';

  let date: Date;
  if (typeof dateInput === 'number' || typeof dateInput === 'string') {
    date = new Date(dateInput);
  } else {
    date = dateInput;
  }

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  });
}
